import { useEffect } from "react";
import { Observer } from "mobx-react";
import { reaction } from "mobx";
import { useRouter } from "next/router";
import Head from "next/head";

import Cart from "components/Shop/Cart/Cart";

import { getCartFromContextAndUser, useShop } from "stores/shop/shop";
import { createUserFromContext, useUser } from "utils/user/lib";
import translationStore from "stores/translation-store";
import { createTranslationsFromContext } from "utils/translations/lib";

function ShopCartPage(props)
{
  const router = useRouter();
  const user = useUser();
  const shop = useShop();
  const { cart } = shop;

  useEffect(() =>
  {
    cart.hydrate(props.cart);
    
    const loginDisposer = reaction(
      () => user.isLoggedIn,
      () => {
        router.replace(router.asPath);
      }
    )

    return () => {
      loginDisposer();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Observer>
    {
      () => {
        const message = user.isLoggedIn && user.subscription.discountCode ? {
          key: `shop.discount.${user.subscription.type}`,
          parameters: {
            name: user.firstName,
            discountCode: user.subscription.discountCode,
          }
        } : null;

        return (
          <>
            <Head>
              <title>{`${translationStore.translate("shop.page.cart.title")} - MyAlbum`}</title>
            </Head>
            <Cart cart={cart} message={message} />
          </>
        );
      }
    }
    </Observer>
  );
}

export default ShopCartPage;

export async function getServerSideProps(context)
{
  const user = await createUserFromContext(context);
  const cart = await getCartFromContextAndUser(context, user);
  const translations = await createTranslationsFromContext(context, user.account?.locale.language);

  return {
    props: {
      cart,
      user: user.JSON,
      translations: translations.JSON,
    }
  }
}